import { ref } from 'vue'

const visible = ref(false)

export function useContactModal() {
  const openContactModal = () => {
    visible.value = true
  }

  const closeContactModal = () => {
    visible.value = false
  }

  return {
    visible,
    openContactModal,
    closeContactModal,
  }
}
